exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ies-switch .input-group__details {\n    display: none;\n}\n\n", ""]);

// exports
